/**
 * Constants for Orders module
 */

export const PERIOD_OPTIONS = [
  { value: 'All', label: 'All' },
  { value: 'TODAY', label: 'Today' },
  { value: 'YESTERDAY', label: 'Yesterday' },
  { value: 'LAST_7_DAYS', label: 'Last 7 Days' },
  { value: 'LAST_30_DAYS', label: 'Last 30 Days' },
] as const;

export const STANDARD_PAGE_SIZES = [10, 20, 50, 100] as const;

export const VALID_TABS: Array<'All' | 'CONFIRMED' | 'READY_FOR_PICKUP' | 'DELIVERED' | 'CANCELLED' | 'RETURN'> = [
  'All',
  'CONFIRMED',
  'READY_FOR_PICKUP',
  'DELIVERED',
  'CANCELLED',
  'RETURN',
];

export const SELECTABLE_STATUSES = ['CONFIRMED', 'READY_FOR_PICKUP'] as const;
